import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const PositionRelativeWrapper = styled.div`
  position: absolute;
  top: ${fromTheme('spacing_large')};
  display: flex;
  z-index: 1;
  justify-content: flex-end;
  width: 100%;

  @media only screen and (min-width: ${fromTheme('screen_medium')}) {
    width: auto;
    z-index: 2;
  }
`;

export const ListViewBtn = styled.span`
  margin-right: auto;
  margin-left: ${fromTheme('spacing_large')};
`;

export const SortFilterBtn = styled.span`
  margin-left: ${fromTheme('spacing_large')};
  margin-right: ${fromTheme('spacing_large')};
`;

export const SortFilterLocations = styled.div`
  .facet-panel {
    position: relative;
    padding-top: 0;

    @media only screen and (max-width: ${fromTheme('screen_medium')}) {
      .filter-search-mobile {
        margin-top: 50px;
      }
    }
  }

  .filter-search-mobile {
    padding: 0 16px;
  }

  .consumer-facets-mobile {
    display: block;

    .sortMenuList {
      width: 100%;
      margin-top: 12px;
      float: none;
    }
  }
`;

export const SortFilterBannerContainer = styled.div`
  padding: ${fromTheme('spacing_medium')};

  .closeBtn {
    padding: 0;
    text-decoration: underline;
    line-height: ${fromTheme('spacing_large')};
    color: #087db9; // static link color, shouldn't be based on customer config
  }
`;
